import { INTEGRATOR_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/integrator_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'INTEGRATOR',
	'purchaseOrdersAdvancedFilters',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
